import React, { useEffect, useRef, useState } from "react";
import RagnaWindow from "./RagnaWindow";
import RagnaModal from "./RagnaModal";
import Select from 'react-select';
import { RDateRangePicker } from "./RDateRangePicker.jsx";
import moment from 'moment';
import axios from 'axios';
import { usePrevious } from "../../Globals";
import { NavLink } from "react-router-dom";
import RagnaLoader from "./RagnaLoader";
import CreatableSelect from 'react-select/creatable';

const default_loader = <RagnaLoader />;

const RagnaDataTable = (props) => {
    const entry_sizes = props.customEntrySizes ?? [10, 50, 100, 1000];
    const _cols = props.columns;
    const _search_cols = props.s_columns;
    const _maxPagination = props.maxPagination ? props.maxPagination : 10;

    const loadingElement = props.loader ? props.loader : default_loader;

    const [isLoading, setLoading] = useState(true);
    const [searchInput, setSearchInput] = useState("");
    const [searchColSelect, setSearchColSelect] = useState(_search_cols[0].col);
    const [tData, setTData] = useState([]);
    const [paginationTiles, setPaginationTiles] = useState([]);
    const [errorState, setErrorState] = useState("");

    const [tblRefresh, setTblRefresh] = useState(-999);

    //modal
    const [modalOpen, setModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [modalBody, setModalBody] = useState(<></>);
    const [modalFooter, setModalFooter] = useState(<></>);

    const [filterModalOpen, setFilterModalOpen] = useState(false);
    const [filterCols, setFilterCols] = useState({});

    const [totalEntries, setTotalEntries] = useState(0);
    const [entryFrom, setEntryFrom] = useState(1);
    const [entryTo, setEntryTo] = useState(1 * entry_sizes[0]);
    const [filteredCount, setFilteredCount] = useState(null);

    const [page, setPage] = useState(1);
    const [entrySize, setEntrySize] = useState(entry_sizes[0]);
    const [orderCol, setOrderCol] = useState(
        props.defaultOrderCol ? props.defaultOrderCol : _cols[0].col
    );
    const [isAsc, setIsAsc] = useState(
        props.defaultOrder != undefined ? props.defaultOrder : true
    );
    const [searchCol, setSearchCol] = useState("");
    const [searchString, setSearchString] = useState("");

    const [maxPages, setMaxPages] = useState(1);

    const [multi_filter, setMulti_filter] = useState({});

    const multiFilterDivs = new Array(props.multiFilterDivs ?? 1).fill(0);

    const [genSearchInput, setGenSearchInput] = useState("");
    const [genSearch, setGenSearch] = useState("");

    const genSearchPrev = usePrevious(genSearch);

    const prevPage = (_) => {
        if (page > 1) setPage(page - 1);
    };
    const nextPage = (_) => {
        if (maxPages > page) setPage(page + 1);
    };

    const [cModalLoading, setCModalLoading] = useState(false);

    const setCModal = (title, body, url) => {
        setModalTitle(title);
        setModalBody(body);
        setModalFooter(
            <>
                <button className="ro-button" onClick={async () => {
                    if (cModalLoading == false) {
                        setCModalLoading(true);
                        await axios.get(url, { withCredentials: true }).then(_ => {
                            setModalOpen(false);
                            setTblRefresh(t => t + 1);
                        }).catch(e => alert(e.message));
                        setCModalLoading(false);
                    }
                }}
                >
                    <span>Yes</span>
                </button>
                <button
                    className="ro-button"
                    style={{ margin: "0 2px" }}
                    onClick={(_) => setModalOpen(false)}
                >
                    <span>No</span>
                </button>
            </>
        );
        setModalOpen(true);
    };

    useEffect((_) => {
        setSearchColSelect(_search_cols[0].col);
        if (props.multiFilter) {
            let s_cols = {};
            _search_cols.forEach((s) => {
                if (s.keyword)
                    s_cols[s.col] = "[]"
                else
                    s_cols[s.col] = ""
            });
            setFilterCols(s_cols);
        }
    }, []);

    useEffect(() => {
        setPage(1);
    }, [entrySize, searchString, isAsc, orderCol, genSearch]);


    useEffect(() => {
        var t0 = performance.now();

        const axiosController = new AbortController();
        setErrorState("");
        setLoading(true);

        var dtable_data =
        {
            entry_size: entrySize,
            order_col: orderCol,
            isAsc: isAsc,
            search_col: searchCol,
            search_string: searchString,
            page: genSearchPrev != null && genSearchPrev != genSearch ? 1 : page,
        };
        if (props.multiFilter) dtable_data.multi_filter = JSON.stringify(multi_filter);
        if (props.generalSearch) {
            dtable_data.general_search = genSearch;

            if (props.onGeneralSearch)
                props.onGeneralSearch(genSearch)
        }

        axiosController.abort();

        axios.get(props.url, {
            params: {
                ...dtable_data
            },
            withCredentials: true
        }, {
            headers: {
                "X-Requested-With": "XMLHttpRequest"
            }
        })
            .then(response => {
                var d = response.data;
                // manipulate the response here
                console.log("Datatable took " + (performance.now() - t0) / 1000 + " seconds to load.");

                //pass filtering as props
                if (props.multiFilter && props.onFilter) {
                    var obj = {};
                    Object.keys(multi_filter).forEach(x => {
                        if (multi_filter[x] != null && multi_filter[x] !== "") {
                            obj[x] = multi_filter[x];
                        }
                    })
                    props.onFilter(obj);
                }

                var max = d.total_count;
                var filtered = null;

                setTData(d.data);

                if (d.filtered_count != null) {
                    max = d.filtered_count;
                    filtered = d.total_count;
                }
                var _maxPages = Math.ceil(max / entrySize);

                setTotalEntries(max);
                setFilteredCount(filtered);
                setEntryFrom(d.entryFrom);
                setEntryTo(d.entryTo);
                setMaxPages(_maxPages);

                var ptiles = [];
                var round_ptile = Math.round(_maxPagination / 2);
                var _start = page - round_ptile <= 0 ? 1 : page - round_ptile;
                if (page + round_ptile >= _maxPages)
                    _start = _maxPages - _maxPagination + 1;
                var _limit =
                    page - round_ptile <= 0
                        ? _maxPagination
                        : _maxPagination + (page - round_ptile) - 1;
                if (page + round_ptile >= _maxPages)
                    _limit = _maxPagination + (page - round_ptile);
                for (let i = _start; i <= _limit; i++) {
                    if (i > _maxPages) break;
                    if (i <= 0) continue;
                    ptiles.push(i);
                }
                setPaginationTiles(ptiles);

                setLoading(false);

                if (props.exposeData) props.exposeData(d.data);
            })
            .catch(function (error) {
                // manipulate the error response here
                setErrorState(<div className="text-center">An error occured. Check console for error details. <a href="#" onClick={_ => setTblRefresh(t => t + 1)}>Click here</a> to reload table.</div>);
                console.log("Server error: " + error);
            });

    }, [entrySize, orderCol, isAsc, searchCol, searchString, page, multi_filter, genSearch, tblRefresh, props.draw, props.refreshTable]);


    useEffect(
        (_) => {
            setSearchInput("");
        },
        [searchColSelect]
    );

    const updateSearch = (_) => {
        setSearchCol(searchColSelect);
        setSearchString(searchInput);
    };

    const setCustomModal = (modal_data) => {
        if (modal_data.reset) modal_data.reset();

        setModalTitle(modal_data.title);
        setModalBody(modal_data.body);
        setModalFooter(modal_data.footer);
        setModalOpen(true);
    };

    const multiFilterRef = useRef(null);

    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        /* Inside of a "useEffect" hook add an event listener that updates
           the "width" state variable when the window size changes */
        window.addEventListener("resize", () => setWidth(window.innerWidth));

        /* passing an empty array as the dependencies of the effect will cause this
           effect to only run when the component mounts, and not each time it updates.
           We only want the listener to be added once */
    }, []);

    const getFlagIfMultiHiddenInput = (col_name) => {
        var _flag = false;

        if (props.multiFilterHideInputIf) {
            var yomama = props.multiFilterHideInputIf;
            var _hideCol = yomama.col;
            var _hideCondition = yomama.condition;
            var _hideValue = yomama.value;
            var _hideCols = yomama.colsToBeHidden;

            if (_hideCols.includes(col_name)) {
                switch (_hideCondition) {
                    case "!=":
                        if (filterCols[_hideCol] !== _hideValue) {
                            _flag = true;
                        }
                        break;
                    //add more cases here, tamads pa
                    default:
                        break;
                }
                if (filterCols[_hideCol] === "") {
                    _flag = false;
                }
            }
        }

        return _flag;
    }

    return (
        <>
            <RagnaModal
                trigName="Open modal1"
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                noBtn={true}
                title={modalTitle}
                body={cModalLoading ? <>Loading...</> : modalBody}
                footer={cModalLoading ? <></> : modalFooter}
            />
            <RagnaWindow
                minHeight={300}
                title={<>{props.title ? props.title : "Data Table"}</>}
                footer={null}
                footer_options={null}
                mainStyle={{
                    width: "100%",
                    maxWidth: props.width ? props.width : "100%",
                    transition: "all .1s",
                }}
                boxStyle={null}
            >
                <div className="container-fluid mdatatable">
                    <div className="row tbl-head">
                        <div className="col-md-6 text-center text-md-start mb-2">
                            Show{" "}
                            <select className="form-select" style={{ display: "inline", width: "auto" }} onChange={(e) => setEntrySize(e.target.value)}>
                                {entry_sizes.map(function (v, i) {
                                    return <option key={"entrySizes-" + i}>{v}</option>;
                                })}
                            </select>{" "}
                            Entries
                        </div>
                        <div
                            className="col-md-6 mb-2 text-center text-md-start d-flex justify-content-md-end justify-content-center"
                            style={{ justifyContent: "flex-end" }}
                        >
                            {
                                props.generalSearch ?

                                    <div className="input-group">

                                        <input className="form-control" type="text" placeholder="Search" value={genSearchInput} onKeyDown={
                                            e => {
                                                if (e.key == 'Enter') setGenSearch(genSearchInput)
                                            }
                                        } onChange={e =>
                                            setGenSearchInput(e.target.value)} />
                                        <button className="btn btn-outline-primary" type="button" onClick={_ => setGenSearch(genSearchInput)}><i className="fa fa-search" /></button>
                                    </div>
                                    : ""
                            }
                            {props.multiFilter ? (
                                <div style={{ flex: "shrink" }}>
                                    <div className="multifilter-count">
                                        <RagnaModal
                                            btnClass="btn btn-secondary"
                                            trigName={
                                                <div className="d-flex" title="nice &#010;&#013; one">
                                                    <i className="fa fa-filter me-1" />
                                                    <span>Filters</span>
                                                    <> {
                                                        Object.keys(multi_filter)
                                                            .filter(v => multi_filter[v] != "" && multi_filter[v] != "[]").length > 0 ?
                                                            <span className="badge rounded-circle bg-danger ms-2">{Object.keys(multi_filter)
                                                                .filter(v => multi_filter[v] != "" && multi_filter[v] != "[]").length} </span> : ""
                                                    }
                                                    </>
                                                </div>
                                            }
                                            width={props.multiFilterWidth}
                                            modalOpen={filterModalOpen}
                                            setModalOpen={setFilterModalOpen}
                                            title="Filtering"
                                            body={
                                                <>
                                                    <div className="color-red">
                                                        {
                                                            props.multiFilterHeader ?? ""
                                                        }
                                                        <div className="text-danger mb-2">
                                                            * Leave input empty to match any
                                                        </div>
                                                    </div>
                                                    <div className="row" ref={multiFilterRef}>
                                                        {
                                                            multiFilterDivs.length > 1 ?
                                                                multiFilterDivs.map(
                                                                    (_, ii) => {
                                                                        const searchColKeys = Object.keys(filterCols);
                                                                        const sliceCount = Math.ceil(searchColKeys.length / (props.multiFilterDivs ?? 1) );
                                                                        const slicedArray = searchColKeys.slice(ii * sliceCount, (ii + 1) * sliceCount);

                                                                        return <div className="col-sm-12 col-md" key={"mFilter-" + ii}>
                                                                            {
                                                                                slicedArray.map((v, i) => {
                                                                                    i += ii * sliceCount;
                                                                                    var s_col = _search_cols[i];
                                                                                    var s_col_options = [];
                                                                                    if (Array.isArray(s_col.options)) {
                                                                                        s_col_options = [{ label: "<Match Any>", value: "" }, ...s_col.options];
                                                                                    } //console.log(s_col_options ? typeof s_col_options : "asd");
                                                                                    function isJsonString(str) {
                                                                                        try {
                                                                                            JSON.parse(str);
                                                                                        } catch (e) {
                                                                                            return false;
                                                                                        }
                                                                                        return true;
                                                                                    }
                                                                                    //check for multiFilterHideInputIf
                                                                                    if (getFlagIfMultiHiddenInput(s_col.col)) {
                                                                                        return <></>
                                                                                    }
                                                                                    return <div key={"mFilterIn-" + v}>
                                                                                        <span>
                                                                                            {
                                                                                                s_col.display
                                                                                            }
                                                                                        </span>
                                                                                        <span>
                                                                                            {
                                                                                                s_col.keyword ? <>
                                                                                                    <CreatableSelect
                                                                                                        isMulti
                                                                                                        placeholder="Input keywords"
                                                                                                        value={isJsonString(filterCols[s_col.col]) ? JSON.parse(filterCols[s_col.col]).map(d => ({ label: d, value: d })) : []}
                                                                                                        onChange={e => {
                                                                                                            if (e != null) setFilterCols(f => ({ ...f, [s_col.col]: JSON.stringify(e.map(ee => ee.value)) }))
                                                                                                            else setFilterCols(f => ({ ...f, [s_col.col]: "[]" }))
                                                                                                        }}
                                                                                                    />
                                                                                                </> :
                                                                                                    (
                                                                                                        s_col.options ?
                                                                                                            <Select menuPortalTarget={document.querySelector('body')}

                                                                                                                menuPlacement="auto"
                                                                                                                onChange={e => {
                                                                                                                    if (e != null) setFilterCols({ ...filterCols, [s_col.col]: e.value })
                                                                                                                    else setFilterCols({ ...filterCols, [s_col.col]: "" })
                                                                                                                    if (props.multiFilterHideInputIf) {
                                                                                                                        var yomama = props.multiFilterHideInputIf;
                                                                                                                        var _hideCol = yomama.col;
                                                                                                                        var _hideCols = yomama.colsToBeHidden;

                                                                                                                        if (s_col.col === _hideCol) {
                                                                                                                            //remove values from hidden cols
                                                                                                                            setFilterCols(ff => {
                                                                                                                                _hideCols.forEach(f => {
                                                                                                                                    ff[f] = "";
                                                                                                                                })
                                                                                                                                return ff;
                                                                                                                            })
                                                                                                                        }
                                                                                                                    }
                                                                                                                }}
                                                                                                                value={typeof filterCols[s_col.col] == "string" ? filterCols[s_col.col] : filterCols[s_col.col].value}
                                                                                                                placeholder="<Match Any>"
                                                                                                                isClearable
                                                                                                                isSearchable
                                                                                                                options={
                                                                                                                    props.multiFilterFilterOptions != null ?

                                                                                                                        Array.isArray(s_col.options) ? (
                                                                                                                            props.multiFilterFilterOptions(s_col.col, filterCols,
                                                                                                                                s_col_options).map((v, i) => {
                                                                                                                                    return {
                                                                                                                                        label: typeof v == "string" ? v : v.label,
                                                                                                                                        value: typeof v == "string" ? v : v.value
                                                                                                                                    }
                                                                                                                                })
                                                                                                                        ) : (
                                                                                                                            Object.keys(props.multiFilterFilterOptions(s_col.col, filterCols, s_col_options)).map((v, i) => {
                                                                                                                                // return <option value={v}>
                                                                                                                                // 	{}
                                                                                                                                // </option>
                                                                                                                                return {
                                                                                                                                    label: props.multiFilterFilterOptions(s_col.col, filterCols, s_col_options)[v],
                                                                                                                                    value: v
                                                                                                                                }
                                                                                                                            })
                                                                                                                        )

                                                                                                                        :
                                                                                                                        Array.isArray(s_col.options) ? (
                                                                                                                            s_col_options.map((v, i) => {
                                                                                                                                return {
                                                                                                                                    label: typeof v == "string" ? v : v.label,
                                                                                                                                    value: typeof v == "string" ? v : v.value
                                                                                                                                }
                                                                                                                            })
                                                                                                                        ) : (
                                                                                                                            Object.keys(s_col_options).map((v, i) => {
                                                                                                                                // return <option value={v}>
                                                                                                                                // 	{}
                                                                                                                                // </option>
                                                                                                                                return {
                                                                                                                                    label: s_col_options[v],
                                                                                                                                    value: v
                                                                                                                                }
                                                                                                                            })
                                                                                                                        )
                                                                                                                }
                                                                                                            />

                                                                                                            // <Select menuPortalTarget={document.querySelector('body')}>
                                                                                                            // 	<option></option>
                                                                                                            // 	{
                                                                                                            // 		
                                                                                                            // 	}
                                                                                                            // </select> 
                                                                                                            : (
                                                                                                                s_col.dateRange ?
                                                                                                                    <RDateRangePicker limitYear={moment().format("YYYY")} yearRange={50}
                                                                                                                        selectedDates={filterCols[v]} dateRangeMode={true}
                                                                                                                        onChange={e => setFilterCols({ ...filterCols, [v]: e })} />
                                                                                                                    :
                                                                                                                    <input
                                                                                                                        className="form-control"
                                                                                                                        value={filterCols[v]}
                                                                                                                        onChange={e => setFilterCols({ ...filterCols, [v]: e.target.value })}
                                                                                                                    />
                                                                                                            )
                                                                                                    )
                                                                                            }
                                                                                        </span>
                                                                                    </div>;
                                                                                })
                                                                            }
                                                                        </div>;
                                                                        //className={`col-md-${12/props.multiFilterDivs}`}
                                                                    }
                                                                )
                                                                :
                                                                Object.keys(filterCols).map((v, i) => {
                                                                    var s_col = _search_cols[i];
                                                                    var s_col_options = [];
                                                                    if (Array.isArray(s_col_options)) {
                                                                        s_col_options = [{ label: "<Match Any>", value: "" }];
                                                                        if (s_col.options)
                                                                            s_col_options.push(s_col.options)
                                                                    }
                                                                    //check for multiFilterHideInputIf

                                                                    if (getFlagIfMultiHiddenInput(s_col.col)) {
                                                                        return <></>
                                                                    }
                                                                    return <div key={"sCols-" + i}>
                                                                        <span>
                                                                            {
                                                                                s_col.display
                                                                            }
                                                                        </span>
                                                                        <span>
                                                                            {
                                                                                s_col.options != null ?
                                                                                    <Select menuPortalTarget={document.querySelector('body')}
                                                                                        onChange={e => setFilterCols({ ...filterCols, [s_col.col]: e.value })}
                                                                                        value={filterCols[s_col.col]?.value}
                                                                                        placeholder="<Match Any>"
                                                                                        isClearable
                                                                                        isSearchable

                                                                                        options={
                                                                                            props.multiFilterFilterOptions ?
                                                                                                props.multiFilterFilterOptions(filterCols[s_col.col],
                                                                                                    Array.isArray(s_col.options) ? (
                                                                                                        s_col_options.map((v, i) => {
                                                                                                            return {
                                                                                                                label: typeof v == "string" ? v : v.label,
                                                                                                                value: typeof v == "string" ? v : v.value
                                                                                                            }
                                                                                                        })
                                                                                                    ) : (
                                                                                                        Object.keys(s_col_options).map((v, i) => {
                                                                                                            // return <option value={v}>
                                                                                                            // 	{}
                                                                                                            // </option>
                                                                                                            return {
                                                                                                                label: s_col_options[v],
                                                                                                                value: v
                                                                                                            }
                                                                                                        })
                                                                                                    )
                                                                                                )
                                                                                                :
                                                                                                Array.isArray(s_col.options) ? (
                                                                                                    s_col_options.map((v, i) => {
                                                                                                        return {
                                                                                                            label: typeof v == "string" ? v : v.label,
                                                                                                            value: typeof v == "string" ? v : v.value
                                                                                                        }
                                                                                                    })
                                                                                                ) : (
                                                                                                    Object.keys(s_col_options).map((v, i) => {
                                                                                                        // return <option value={v}>
                                                                                                        // 	{}
                                                                                                        // </option>
                                                                                                        return {
                                                                                                            label: s_col_options[v],
                                                                                                            value: v
                                                                                                        }
                                                                                                    })
                                                                                                )
                                                                                        }
                                                                                    />

                                                                                    // <select>
                                                                                    // 	<option></option>
                                                                                    // 	{
                                                                                    // 		
                                                                                    // 	}
                                                                                    // </select> 
                                                                                    : (
                                                                                        s_col.dateRange ?
                                                                                            <RDateRangePicker limitYear={moment().format("YYYY")} yearRange={50}
                                                                                                selectedDate={filterCols[v]} dateRangeMode={true}
                                                                                                onChange={e => setFilterCols({ ...filterCols, [v]: e === "" ? "" : moment(e).format("YYYY-MM-DD") })} />
                                                                                            :
                                                                                            <input
                                                                                                className="form-control"
                                                                                                value={filterCols[v]}
                                                                                                onChange={e => setFilterCols({ ...filterCols, [v]: e.target.value })}
                                                                                            />
                                                                                    )
                                                                            }
                                                                        </span>
                                                                    </div>;
                                                                })
                                                        }

                                                    </div>
                                                </>
                                            }
                                            footer={
                                                <>
                                                    <button
                                                        className="ro-button mr-2"
                                                        onClick={
                                                            () => {
                                                                let s_cols = {};
                                                                _search_cols.forEach((s) => {
                                                                    s_cols[s.col] = ""
                                                                });
                                                                setFilterCols(s_cols);
                                                            }
                                                        }
                                                    >
                                                        <span><i className="fa fa-redo" /> Reset Filters</span>
                                                    </button>
                                                    <button
                                                        className="ro-button mr-2"
                                                        onClick={
                                                            () => {
                                                                setPage(1);
                                                                setFilterModalOpen(false);
                                                                setMulti_filter(filterCols);
                                                            }
                                                        }
                                                    >
                                                        <span><i className="fa fa-search" /> Search</span>
                                                    </button>
                                                </>
                                            }
                                        />
                                    </div>
                                </div>
                            ) : (
                                props.showColumnSearch ?
                                    <>
                                        <select
                                            value={searchColSelect}
                                            onChange={(e) => setSearchColSelect(e.target.value)}
                                        >
                                            {_search_cols.map(function (v, i) {
                                                return (
                                                    <option value={v.col} key={"colSearch-" + i}>
                                                        {v.display}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                        <form
                                            className="mdtbl_search"
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                updateSearch();
                                            }}
                                        >
                                            {_search_cols.filter((v) => v.col == searchColSelect)[0].options ? (
                                                <select
                                                    value={searchInput}
                                                    onChange={(e) => setSearchInput(e.target.value)}
                                                >
                                                    <option></option>
                                                    {_search_cols.filter((v) => v.col == searchColSelect)[0].options ? (
                                                        _search_cols
                                                            .filter((v) => v.col == searchColSelect)[0]
                                                            .options.map((o, o_index) => (
                                                                //_search_cols.filter(v => v.col == searchColSelect)[0].options[o]}
                                                                <option key={"sColSel-" + o_index} value={typeof o == "string" ? o : o.value}>
                                                                    {typeof o == "string" ? o : o.display}
                                                                </option>
                                                            ))
                                                    ) : (
                                                        <></>
                                                    )}
                                                </select>
                                            ) : (
                                                <input onChange={(e) => setSearchInput(e.target.value)} />
                                            )}

                                            <button onClick={updateSearch} type="button" className="ro-button">
                                                <span>Search</span>
                                            </button>
                                            <input type="submit" className="d-none" />
                                        </form>
                                    </>
                                    : <></>
                            )}
                        </div>
                    </div>
                    <div className="tbl-main table-responsive">
                        <table className="table table-sm" style={{ width: 800, minWidth: "100%" }}>
                            <thead>
                                <tr>
                                    {_cols.map(function (v, i) {
                                        return (
                                            <th
                                                key={"th-" + i}
                                                className={`${v.center ? " mcenter" : ""}
													${v.lg ? " lg" : ""}
													${v.dontOrder ? "" : "orderable"
                                                    }`}
                                                style={v.customStyle ?? {} }
                                                onClick={(_) => {
                                                    if (!v.dontOrder) {
                                                        setOrderCol(v.col);
                                                        if (orderCol == v.col) setIsAsc(!isAsc);
                                                        else setIsAsc(true);
                                                    }
                                                }}
                                            >
                                                {v.display}
                                                <span style={{ position: "relative", marginRight: "5px" }}>
                                                    {v.dontOrder ? (
                                                        <></>
                                                    ) : (
                                                        <>
                                                            <i
                                                                className={
                                                                    "fa fa-caret-up isAsc " +
                                                                    (isAsc && orderCol == v.col ? "active" : "")
                                                                }
                                                            />
                                                            <i
                                                                className={
                                                                    "isDesc fa fa-caret-down " +
                                                                    (!isAsc && orderCol == v.col ? "active" : "")
                                                                }
                                                            />
                                                        </>
                                                    )}
                                                </span>
                                            </th>
                                        );
                                    })}
                                    {props.actions ? <th>Actions</th> : <></>}
                                </tr>
                            </thead>
                            <tbody style={{ position: "relative" }}>
                                {
                                    errorState != "" ? errorState : (

                                        isLoading ?
                                            <tr>
                                                <td colSpan={9999} style={{ textAlign: "center", fontSize: 15, padding: 20, pointerEvents: "none" }}>
                                                    {loadingElement}
                                                </td>
                                            </tr>
                                            : tData.map(function (v, i) {
                                                return (
                                                    <tr key={"tr-" + i} >
                                                        {_cols.map(function (vv, ii) {
                                                            return (
                                                                <td key={"td-" + ii} className={`${vv.center ? " mcenter" : ""}`}>
                                                                    {vv.customValue ? vv.customValue(v) : v[vv.col]}
                                                                </td>
                                                            );
                                                        })}

                                                        {props.actions ? (
                                                            <td>
                                                                {props.actions.map(function (vv, ii) {
                                                                    if (vv.hideIf) return;
                                                                    if (vv.action == "url")
                                                                        return (
                                                                            <NavLink
                                                                                className="ro-button"
                                                                                key={"td-action-" + ii}
                                                                                to={vv.content(v)}
                                                                            >
                                                                                <span>{vv.display}</span>
                                                                            </NavLink>
                                                                        );
                                                                    if (vv.action == "url_confirm")
                                                                        return (
                                                                            <button
                                                                                className="ro-button"
                                                                                key={"td-action-" + ii}
                                                                                onClick={(_) => setCModal(vv.title, vv.body(v), vv.content(v))}
                                                                            >
                                                                                <span>{vv.display}</span>
                                                                            </button>
                                                                        );
                                                                    if (vv.action == "modal")
                                                                        return (
                                                                            <button
                                                                                className="ro-button"
                                                                                key={"td-action-" + ii}
                                                                                onClick={_ => {
                                                                                    if (vv.onClick) {
                                                                                        vv.onClick(v);
                                                                                    }
                                                                                    setCustomModal({ reset: vv.reset, body: vv.body(v), title: vv.title, footer: vv.footer(v, setModalOpen, _ => setTblRefresh(t => t + 1)) });//(vv.content(v, setModalOpen ));
                                                                                }}
                                                                            >
                                                                                <span>{vv.display}</span>
                                                                            </button>
                                                                        );
                                                                    if (vv.action == "button")
                                                                        return (
                                                                            <button
                                                                                className="ro-button"
                                                                                key={"td-action-" + ii}
                                                                                onClick={_ => {
                                                                                    if (vv.onClick) {
                                                                                        vv.onClick(v);
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <span>{vv.display}</span>
                                                                            </button>
                                                                        );
                                                                    return <vv.component key={"td-action-" + ii} data={v} />
                                                                })}
                                                            </td>
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </tr>
                                                );
                                            })
                                    )

                                }
                                {
                                    !isLoading ?
                                        (tData.length == 0 ? (
                                            <tr colSpan={9999} style={{ display: isLoading ? "none" : "initial" }}>
                                                <td style={{ textAlign: "center", fontSize: 15, padding: 20, pointerEvents: "none" }}>
                                                    No data found..
                                                </td>
                                            </tr>
                                        ) : ""
                                        ) : (
                                            <></>
                                        )}
                            </tbody>
                        </table>
                    </div>
                    <div className="row tbl-footer">
                        <div className="col-md-4 mb-2 mb-md-0 text-center text-md-left">
                            Showing {entryFrom} to {entryTo} of {totalEntries} entries{" "}
                            {filteredCount != null
                                ? " (filtered from " + filteredCount + " total entries)"
                                : ""}
                        </div>
                        <div className="col d-flex justify-content-center justify-content-md-end">
                            <button className="ro-button" onClick={(_) => setPage(1)}>
                                <i className="fa fa-backward" />
                            </button>
                            <button className="ro-button mx-2" onClick={prevPage}>
                                <i className="fa fa-caret-left" />
                            </button>

                            <div className="pageTitles">
                                {paginationTiles.map(function (v, i) {
                                    return (
                                        <button
                                            className={"mpagination " + (page == v ? "active" : "")}
                                            key={"pagination-" + i}
                                            onClick={(_) => setPage(v)}
                                        >
                                            {v}
                                        </button>
                                    );
                                })}
                            </div>
                            <button className="ro-button mx-2" onClick={nextPage}>
                                <i className="fa fa-caret-right" />
                            </button>
                            <button className="ro-button" onClick={(_) => setPage(maxPages)}>
                                <i className="fa fa-forward" />
                            </button>
                        </div>
                    </div>
                </div>
            </RagnaWindow>
        </>
    );
};


export default RagnaDataTable;